<template>
    <div class="py-4 container-fluid">
      <div class=" row">
        <div class="col-12">
          <TestsTable :tests="testsList"/>
        </div>
      </div>
      
    </div>
</template>
  
<script>
import axios from "axios";
import TestsTable from "./components/Table.vue";  
export default {
    name: "tables",
    components: {
        TestsTable,
    },
    data() {
        return {
            testsList:[],
        };
    },
    methods:{
        async fetchTests(config){
            let self=this;
            axios.get(this.$store.state.apiURL+'?action=list&object=view_tests&recperpage=all',config)
            .then((result)=>{
                console.log(result);
                this.testsList=result.data.view_tests.map(item=>{return{id:item.id, clasification:item.clasification,code:item.code, description:item.description, type:item.test_type+' - Conservable hasta '+ item.max_live+' Horas', instructions:item.instructions, color:item.color}});
            })
            .catch(error => {
                console.log(error)
                self.$swal({
                    title: 'Sesión',
                    text: 'El tiempo de sesión a vencido, ingresa nuevamente.',
                    type: 'warning',
                    icon:'warning',
                    showCancelButton: false,
                    confirmButtonColor:'#bf4f51',
                    showCloseButton: true,
                    showLoaderOnConfirm: false  
                }).then(function(){
                    localStorage.removeItem('user');
                    localStorage.removeItem('accessToken');
                    self.$router.push('/signin');
                });    
            });
        }
    },
    mounted() {
        const token = localStorage.getItem("accessToken");
        const config = {headers: {"Authorization": `Bearer ${token}`}};
        this.fetchTests(config);
    },
};
</script>
  